function runBatch(batch) {
  for (const retire of batch.splice(0)) {
    try {
      retire();
    } catch {
    }
  }
}
function retireGpuResources(engine, retirement) {
  (engine._retirements ??= []).push(retirement);
}
function flushGpuResourceRetirements(engine) {
  const batch = engine._retirements;
  if (!batch) {
    return;
  }
  engine._retirements = null;
  const inFlight = engine._retiring ??= [];
  inFlight.push(batch);
  queueMicrotask(() => {
    void engine._device.queue.onSubmittedWorkDone().then(() => {
      const index = inFlight.indexOf(batch);
      if (index >= 0) {
        inFlight.splice(index, 1);
      }
      runBatch(batch);
    }).catch(() => void 0);
  });
}
function disposeGpuResourceRetirements(engine) {
  const batch = engine._retirements;
  const inFlight = engine._retiring;
  engine._retirements = null;
  engine._retiring = null;
  if (batch) {
    runBatch(batch);
  }
  inFlight?.forEach(runBatch);
}

export { disposeGpuResourceRetirements, flushGpuResourceRetirements, retireGpuResources };
//# sourceMappingURL=gpu-resource-retirement.js.map
